import { FirebaseClient } from '@/api/firebaseClient';
import { QUERY_KEYS } from '@/api/queries';
import { Loading } from '@/components/Loading';
import Questionnaire from '@/components/Wizard/Questionnaire';
import { WizardData } from '@/components/Wizard/store';
import { useInvalidatingMutation } from '@/hooks/useInvalidatingMutation';
import { useNavigate } from 'react-router-dom';
import RotatingText from 'react-rotating-text';
import { Overlay } from '@/components/Overlay';
import { useTranslation } from 'react-i18next';
import { SupportedLanguage } from '@packages/types';

const fbClient = new FirebaseClient();

export const CreateSpeech = () => {
  const navigate = useNavigate();
  const { mutateAsync: createSpeech, isPending } = useInvalidatingMutation([QUERY_KEYS.SPEECH], {
    mutationFn: fbClient.createSpeech.bind(this),
  });

  const { t, i18n } = useTranslation();

  const onFinish = async (data: WizardData) => {
    const result = await createSpeech({
      bride: data.bride,
      bride_pronoun: data.bride_pronoun,
      groom: data.groom,
      groom_pronoun: data.groom_pronoun,
      known_since: data.known_since,
      language: i18n.language as SupportedLanguage,
      memories: data.memories,
      name: data.name,
      email: data.email,
      relationship: data.relationship,
      style: data.style,
    });

    navigate(`/speech/${result.data.id}`);
  };
  return (
    <div className="w-full h-full grid place-items-center">
      {isPending ? (
        <Overlay>
          <span className="text-primary">
            <Loading size={60} />
          </span>
          <h1 className="text-xl text-foreground mt-4">
            <RotatingText items={[t('wizard.loadingText1'), t('wizard.loadingText2')]} />
          </h1>
        </Overlay>
      ) : null}

      <Questionnaire onFinish={onFinish} />
    </div>
  );
};
